import { Text } from '@mantine/core'
import clsx from 'clsx'
import { IconProps, IconChevronRight } from '@tabler/icons-react'
import classes from './Stat.module.css'
import { getRankSuffix } from '../../common/helpers'
import { Typography } from '../../common/typography'

export default function Stat({
  title,
  icon: Icon,
  iconColor,
  value,
  isValueSub,
  isTeamHeader,
  background,
  onClick,
  valueType,
}: {
  title?: string
  icon?: React.ComponentType<IconProps>
  iconColor?: string
  value: number | string | null
  isValueSub?: boolean
  isTeamHeader?: boolean
  background?: 'white' | 'gray'
  onClick?: () => void
  valueType?: string
}) {
  const content = (
    <div
      className={clsx(
        classes.container,
        { [classes.whiteBackground]: background === 'white' },
        { [classes.grayBackground]: background === 'gray' },
        { [classes.clickable]: !!onClick }
      )}
    >
      <Typography fw={500} ta="center" lh="130">
        {title}
      </Typography>

      {Icon ? (
        <div className={classes.stat_wrapper}>
          <Icon
            className={clsx(classes.stat_icon, {
              [classes.teamHeaderIcon]: isTeamHeader,
            })}
            color={iconColor}
          />
          {isValueSub && typeof value === 'number' ? (
            <Text className={classes.value} component="h4">
              {value}
              <sup className={classes.sup}>{getRankSuffix(value)}</sup>
            </Text>
          ) : (
            <Text className={classes.value} component="h4">
              {value != null ? value : '-'}
            </Text>
          )}
        </div>
      ) : (
        <Text className={classes.value} component="h4">
          {isValueSub && typeof value === 'number' ? (
            <>
              {value}
              <sup className={classes.sup}>{getRankSuffix(value)}</sup>
            </>
          ) : value != null ? (
            valueType ? (
              `${value} ${valueType}`
            ) : (
              value
            )
          ) : (
            '-'
          )}
        </Text>
      )}
    </div>
  )

  if (onClick) {
    return (
      <div className={classes.wrapper} onClick={onClick}>
        {content}
        <IconChevronRight className={classes.chevron} />
      </div>
    )
  }

  return content
}
